import types from './mutations-types';
import { MutationTree } from 'vuex';
import { FeatureStateShape } from 'store';

export default {
	[types.ADD_FEATURES](state, features) {
		state.features = features;
	}
} as MutationTree<FeatureStateShape>;
